import React, { useEffect, useState } from "react";
import client from "@/lib/api";
import { X, CheckCircle, Loader2 } from "lucide-react";

// One-tap disposition picker shown when a unit clears its call from the MDT.
export default function MDTClearSheet({ open, onClose, onSubmit, busy }) {
  const [groups, setGroups] = useState([]);
  const [code, setCode] = useState(null);
  const [narrative, setNarrative] = useState("");

  useEffect(() => {
    if (open && groups.length === 0) client.get("/disposition-codes").then((r) => setGroups(r.data)).catch(() => {});
    if (open) { setCode(null); setNarrative(""); }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!open) return null;
  const pick = (c) => { setCode(c.code); setNarrative((n) => n.trim() ? n : `${c.label}. `); };

  return (
    <div data-testid="mdt-clear-sheet" className="fixed inset-0 z-[1500] bg-black/70 flex items-end sm:items-center justify-center p-3" onClick={onClose}>
      <div className="w-full max-w-lg bg-[#141518] border border-[#2C2D35] rounded-lg max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-[#141518] px-4 py-3 border-b border-[#2C2D35] flex items-center gap-2">
          <CheckCircle size={16} className="text-[#16A34A]" />
          <div className="font-head font-bold text-sm text-white">CLEAR CALL — PICK DISPOSITION</div>
          <button data-testid="mdt-clear-sheet-close" onClick={onClose} className="ml-auto text-[#6B7280] hover:text-white"><X size={16} /></button>
        </div>
        <div className="p-4 space-y-3">
          {groups.map((g) => (
            <div key={g.group}>
              <div className="font-mono text-[9px] uppercase text-[#9CA3AF] mb-1">{g.group}</div>
              <div className="flex flex-wrap gap-1.5">
                {g.codes.map((c) => (
                  <button key={c.code} data-testid={`disp-code-${c.code}`} onClick={() => pick(c)} title={c.desc}
                    className={`px-2 py-1.5 text-[11px] font-mono font-bold rounded-sm border transition-colors ${code === c.code ? "bg-[#16A34A] border-[#16A34A] text-white" : "border-[#2C2D35] text-[#E5E7EB] hover:border-[#16A34A]"}`}>
                    {c.code} <span className="font-normal opacity-80">{c.label}</span>
                  </button>
                ))}
              </div>
            </div>
          ))}
          <div>
            <div className="font-mono text-[9px] uppercase text-[#9CA3AF] mb-1">Narrative (required — goes on the closed call)</div>
            <textarea data-testid="disp-narrative" rows={2} value={narrative} onChange={(e) => setNarrative(e.target.value)}
              className="w-full bg-[#0d0e11] border border-[#2C2D35] px-2.5 py-2 text-sm font-mono text-white outline-none focus:border-[#16A34A]"
              placeholder="Brief court-ready narrative…" />
          </div>
          <button data-testid="disp-submit" disabled={busy || !code || !narrative.trim()} onClick={() => onSubmit(code, narrative.trim())}
            className="w-full py-2.5 bg-[#16A34A] hover:bg-[#15803d] disabled:opacity-40 text-white font-head font-bold text-sm flex items-center justify-center gap-2">
            {busy ? <Loader2 size={15} className="animate-spin" /> : <CheckCircle size={15} />} CLEAR &amp; CLOSE WITH {code || "DISPOSITION"}
          </button>
          <button data-testid="disp-clear-only" disabled={busy} onClick={() => onSubmit(null, "")}
            className="w-full py-2 border border-[#2C2D35] text-[#9CA3AF] font-mono text-xs uppercase hover:text-white">
            Clear WITHOUT disposition (call stays open for dispatch)
          </button>
        </div>
      </div>
    </div>
  );
}
